import FalconCardHeader from 'components/common/FalconCardHeader';
import { useAuth } from 'context/AuthContext';
import { getGroupedPermissions, getUserProfileData } from 'helpers/userProfile';
import React from 'react';
import { Badge, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const AccountSettings = () => {
  const { t } = useTranslation();
  const { userData } = useAuth();
  const { companyName, profileName, membershipStatus, permissions } =
    getUserProfileData(userData);
  const groupedPermissions = getGroupedPermissions(permissions);

  const statusLabel =
    typeof membershipStatus === 'boolean'
      ? membershipStatus
        ? t('USER_PROFILE.STATUS.ACTIVE')
        : t('USER_PROFILE.STATUS.INACTIVE')
      : membershipStatus || t('USER_PROFILE.NOT_AVAILABLE');

  return (
    <Card className="mb-3">
      <FalconCardHeader title={t('USER_SETTINGS.WORKSPACE.TITLE')} />
      <Card.Body className="bg-light">
        <p className="text-600 mb-4">{t('USER_SETTINGS.WORKSPACE.DESCRIPTION')}</p>

        <div className="border rounded-3 p-3 mb-3 bg-white dark__bg-1000">
          <div className="d-flex justify-content-between mb-2">
            <span className="text-600">{t('USER_PROFILE.FIELDS.COMPANY')}</span>
            <span className="text-900 fw-semi-bold">
              {companyName || t('USER_PROFILE.NOT_ASSIGNED')}
            </span>
          </div>
          <div className="d-flex justify-content-between mb-2">
            <span className="text-600">{t('USER_PROFILE.FIELDS.PROFILE')}</span>
            <span className="text-900 fw-semi-bold">
              {profileName || t('USER_PROFILE.NOT_ASSIGNED')}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <span className="text-600">{t('USER_PROFILE.FIELDS.MEMBERSHIP_STATUS')}</span>
            <span className="text-900 fw-semi-bold">{statusLabel}</span>
          </div>
        </div>

        <div className="fs--2 text-600 text-uppercase fw-semi-bold mb-2">
          {t('USER_SETTINGS.WORKSPACE.PERMISSION_GROUPS')}
        </div>
        <div className="d-flex flex-wrap gap-2">
          {groupedPermissions.length ? (
            groupedPermissions.map(group => (
              <Badge key={group.module} bg="soft-primary" className="text-primary px-3 py-2">
                {t(`ACCESS.PERMISSIONS.MODULES.${group.module}.TITLE`, {
                  defaultValue: group.module
                })}{' '}
                ({group.items.length})
              </Badge>
            ))
          ) : (
            <span className="text-500">{t('USER_PROFILE.PERMISSIONS_VIEW.EMPTY')}</span>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default AccountSettings;
